import React from 'react';
import { Link } from 'react-router-dom';
import minDesEcoPro from '../../img/MinDesEcoPro.png';

const MinDesEcoPro = () => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" >
            <div className="container section">
               <div className="row">
                  <div className="center-vertical">
                     <div className="col s12 m12 l6 x6 center">
                        <Link to="https://proveedores.registrominero.jujuy.gob.ar/registro?filter[status][0]=6&filters[query]=LATITUD&page=1"  target="_blank"><img src={minDesEcoPro} class="responsive-img"/></Link>
                     </div>
                     <div className="col s12  m12 l6  x6 center text-white">
                        <strong style={{"font-size":"18px"}}>Nos encontramos incluidos en el registro provincial de proveedores locales de empresas mineras</strong><br/><br/><br/>
                        <Link to="https://proveedores.registrominero.jujuy.gob.ar/registro?filter[status][0]=6&filters[query]=LATITUD&page=1" target="_blank" class="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Visitar
                           <i className="material-icons right">send</i>
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>      
      </>
   )
}

export default MinDesEcoPro